import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import InvoiceForm from "./components/form";
import InvoiceTable from "./components/table";
import InvoiceService from "../../services/invoiceService";

import { apiURL } from "../../utlis/config";
import DateRangePicker from "../../components/common/dateRangePicker";
import Search from "../../components/common/search";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateInvoice extends Component {
  state = {
    infoData: [],
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
    searchText: "",
  };
  componentWillMount() {
    console.log("-----DataTableComponent---");
    // this.setState({ infoData: data });
    // this.setState({ trainings: store.get("myCart") });
    // InvoiceService .fetchDetectedInfo().then(response => {
    //   // //console.log("response", response[0] === "{");
    //   toast.success("List fetched successfully!");
    //   // if (response[0] === "{") {
    //   //   this.setState({ infoData: [JSON.parse(response)] });
    //   // } else if (response[0] === "[") {
    //   //   this.setState({ infoData: JSON.parse(response) });
    //   // } else {
    //   //   this.setState({ infoData: [] });
    //   // }
    // });
  }
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { invoiceStatus } = params;
    this.setState({ loader: true, invoiceStatus, loading: true }, function () {
      this.callApiInfo();
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { invoiceStatus } = params;
    if (this.state.invoiceStatus !== invoiceStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          invoiceStatus: invoiceStatus,
          loading: true,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const {
      invoiceStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;
    InvoiceService.fetchInvoice(
      undefined,
      invoiceStatus,
      pageSize,
      page,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response?.data?.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.invoices,
          totalRecords: totalRecords,
          loading: false,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
          loading: false,
        });
      }
    });
    this.setState({ loader: false });
  };

  addInvoiceForm = (data) => {
    const { isEdit, info, imageUrl } = this.state;
    this.setState({ loader: true });
    data["imageUrl"] = imageUrl;
    data["invoiceId"] = isEdit ? info._id : undefined;
    var method = isEdit ? "PUT" : "POST";
    InvoiceService.addInvoiceInfo(data, method).then((response) => {
      if (!response.error) {
        this.callApiInfo();
        // this.props.history.push("/dealer/inbox");
      }
      // //console.log("response", response[0] === "{");
      // toast.success("List fetched successfully!");
      // if (response[0] === "{") {
      //   this.setState({ infoData: [JSON.parse(response)] });
      // } else if (response[0] === "[") {
      //   this.setState({ infoData: JSON.parse(response) });
      // } else {
      //   this.setState({ infoData: [] });
      // }
    });
  };

  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };

  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        if (searchText && searchText !== "" && searchText.length > 0) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };

  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeActive = (invoiceId, value, index) => {
    console.log({ invoiceId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    InvoiceService.onInvoiceReady(invoiceId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      invoiceStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;
    console.log({ loading, page, pageSize, totalRecords });
    // const propsDaterangePicker = {
    //   changeRangePicker: (startDate, endDate) => {
    //     //console.log({ startDate });
    //     //console.log({ endDate });
    //   }
    // };
    const invoiceFormProps = {
      info: info || {},
      active: this.state.active,
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeInvoiceId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addInvoiceForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      // InvoiceForm: infoData,
    };
    const propsTable = {
      invoiceStatus: invoiceStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditInvoiceInfo: (index, info) => {
        // window.open(apiURL + response.data, "_blank");
        window.open(
          `${apiURL}/invoice/${info._id}/invoice-${info._id}.pdf`,
          "_blank"
        );
        // this.props.history.push("/invoices/" + info._id + "/update");
        // this.setState({
        //   modalFormShow: true,
        //   isEdit: true,
        //   info,
        //   imageUrl: info.imageUrl,
        // });
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    // const propsSearchText = {
    //   searchText: this.state.searchText,
    //   onChangeText: (searchText) => {
    //     this.onSearchText(searchText);
    //   },
    // };
    return (
      <Fragment>
        <Breadcrumb title={invoiceStatus} parent="Invoice" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react">
                  <div className="row m-b-10">
                    <div className="col-sm-4">
                      <Button
                        className="btn btn-danger"
                        onClick={
                          () => this.props.history.push("/invoices/add")
                          // this.setState({
                          //   modalFormShow: true,
                          //   isEdit: false,
                          //   info: undefined,
                          // })
                        }
                      >
                        Add New Invoice
                      </Button>{" "}
                    </div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <InvoiceTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalFormShow}
          toggle={() => this.onClickToggle()}
          size="lg"
        // style={{ width: "80%", maxWidth: "90%" }}
        >
          <ModalHeader toggle={() => this.onClickToggle()}>
            {isEdit ? "Update invoice info" : "Add Invoice"}
          </ModalHeader>
          <ModalBody>
            <InvoiceForm {...invoiceFormProps} />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default CreateInvoice;
